export default __webpack_public_path__ + "static/media/BowtieThumb400.7ac408b2.jpg";